import { captureException } from "@sentry/nextjs";
import { fromPromise } from "xstate";

import { verifyRecaptcha, type RecaptchaVerifyResponse } from "@/lib/utils/recaptcha";

export type VerifyRecaptchaInput = { action: string; siteKey: string };

export class RecaptchaVerificationError extends Error {
  constructor(public readonly reason: string) {
    super(`recaptcha_verification_failed:${reason}`);
    this.name = "RecaptchaVerificationError";
  }
}

export const verifyRecaptchaActor = fromPromise<RecaptchaVerifyResponse, VerifyRecaptchaInput>(
  async ({ input }) => {
    let result: RecaptchaVerifyResponse;
    try {
      result = await verifyRecaptcha(input.action, input.siteKey);
    } catch (error) {
      // Fail-open on infrastructure errors (script not loaded, timeout, network failure) —
      // log to Sentry but let the machine advance so a broken reCAPTCHA never blocks users.
      captureException(error);
      return { success: true };
    }

    if (!result.success) {
      throw new RecaptchaVerificationError(result.reason ?? "unknown");
    }
    return result;
  },
);
